// Remembers how tall each widget was last time, per screen-width band, so its loading placeholder
// reserves the same space on the next visit and nothing below jumps when the data arrives. A
// per-viewer convenience in browser storage: heights only (no data), and safe to lose.
const band = () => Math.round(window.innerWidth / 160);
const key = (dashboardId: string, widgetId: string) => `msld.h:${dashboardId}:${widgetId}:${band()}`;

export function rememberedHeight(dashboardId: string, widgetId: string): number | null {
  try {
    const v = Number(localStorage.getItem(key(dashboardId, widgetId)));
    return Number.isFinite(v) && v > 0 ? v : null;
  } catch {
    return null;
  }
}

export function rememberHeight(dashboardId: string, widgetId: string, height: number) {
  try {
    if (height > 0) localStorage.setItem(key(dashboardId, widgetId), String(Math.round(height)));
  } catch {
    /* storage unavailable: placeholders fall back to their default shape */
  }
}
